<template>
  <Profile :view-name="$route.name" :user-details="userDetails"></Profile>
</template>

<script>
import Profile from '@/components/Profile'
import { mapGetters } from 'vuex'
export default {
  components: {
    Profile
  },
  data () {
    return {
      userDetails: null
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getOtherUserProfileDetails'
    ])
  },
  watch: {
    getOtherUserProfileDetails (newDetails, oldDetails) {
      if (newDetails !== null && newDetails !== 'user data not available') {
        this.userDetails = this.$store.getters.getOtherUserProfileDetails
      }
    },
    '$route' (to, from) {
      document.title = this.$route.name + ' - ThinkTank'
      this.loadUserDetails()
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    this.loadUserDetails()
  },
  methods: {
    loadUserDetails: function () {
      this.$store.dispatch('otherUser', this.$route.params.name)
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/UserProfile.vue